export const TREATMENTS = {
  SOLID: 'solid',
  OUTLINE: 'outline',
  LINK: 'link',
  GLASS: 'glass',
  DIAGONAL_STRIPED: 'diagonalStriped',
  TEXT_ICON: 'textIcon',
  WAVY: 'wavy'
};
